/* eslint-disable */
import { AxiosInstance, AxiosResponse } from 'axios'
import { Exactly } from './utils'

export type OperationWithAxiosResponse = <T extends Exactly<Request, T>>(request: T) => Promise<AxiosResponse<Response>>
export const operationWithAxiosResponse = <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<AxiosResponse<Response>> => {
  return axios.request({
    url: `/user/${encodeURIComponent(request.path['email'] as any)}/reset-password`,
    // @ts-ignore for sm-axios
    urlTemplate: '/user/{email}/reset-password',
    method: 'POST',
  })
}

/**
 * sends reset password email
 */
export type Operation = <T extends Exactly<Request, T>>(request: T) => Promise<Response>
export const operation = async <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<Response> => {
  return (await operationWithAxiosResponse(axios, request)).data
}

export interface Request {
  path: {
    email: string
  }
}

export interface Response {
  /**
   * whether the user is in the password-reset phase or activation phase
   */
  state?: 'RESET' | 'ACTIVATE'
  [k: string]: any
}

